import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

// Any value coming through toast title/description that isn't a string, number
// or React element gets stringified here. React refuses to render a plain
// object as a child (error #31 → whole page goes blank), and we've been bitten
// by callers passing FastAPI Pydantic error arrays straight through. A defensive
// coercion at the render boundary means one such caller can no longer take the
// entire PWA down.
function safeToastChild(value) {
  if (value == null || value === false) return null;
  if (typeof value === "string" || typeof value === "number") return value;
  if (typeof value === "object" && "$$typeof" in value) return value; // React element
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const safeTitle = safeToastChild(title);
        const safeDescription = safeToastChild(description);
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {safeTitle != null && <ToastTitle>{safeTitle}</ToastTitle>}
              {safeDescription != null && (
                <ToastDescription>{safeDescription}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
